var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.site == 'elementsone')?_c('elements-one-page'):_c('el-page')}
var staticRenderFns = []

export { render, staticRenderFns }